import React from 'react'
import { Helmet } from 'react-helmet-async'
import ContactContent from '../components/contact/ContactContent'

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us - A Plus A Driving School</title>
        <meta name="description" content="Get in touch with A Plus A Driving School. Visit our office, call us, or send us a message." />
      </Helmet>
      <ContactContent />
    </>
  )
}

